import React, { useEffect, useState } from 'react';

//import Scss
import './assets/scss/themes.scss';

//imoprt Route
import Route from './Routes';

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// Fake Backend 
import fakeBackend from "./helpers/AuthType/fakeBackend";
import { getCookie } from 'utils/cookie';
import { setAuthorization } from 'utils/axiosClient';
import useCheckVersion from 'hooks/useCheckVersion';
import { useOfflineToast } from 'hooks/useOfflineToast';
import ReactGA from 'react-ga4';
import { GA_MEASUREMENT_ID } from 'constants/global';
import { initAdsTracking } from 'utils/adsTracking';


// Activating fake backend
fakeBackend();

const token = getCookie('agencyAuthToken');
if (token) {
  setAuthorization(token);
}

function App() {

  useCheckVersion();

  useOfflineToast();

  if (process.env.REACT_APP_ENV === 'production') {
    ReactGA.initialize(GA_MEASUREMENT_ID)
  }

  useEffect(() => {
    initAdsTracking();
  }, []);

  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
